import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CONNECTION_OPTIONS, STEP_STATUS } from '../layouts/WhatsApp/components/utilities/constants';

const useWhatsAppOnboarding = () => {
  const [step, setStep] = useState(1);
  const [eligibilityStep, setEligibilityStep] = useState(1);
  const [connectionOption, setConnectionOption] = useState('');
  const [phoneValidationOption, setPhoneValidationOption] = useState('');
  const [subStep, setSubStep] = useState('');
  const [existingStep, setExistingStep] = useState(1);
  const [stepStatus, setStepStatus] = useState({
    step1: STEP_STATUS.ACTIVE,
    step2: '',
    step3: '',
    step4: '',
  });
  const [eligibilityStatus, setEligibilityStatus] = useState({
    step1: STEP_STATUS.ACTIVE,
    step2: STEP_STATUS.INACTIVE,
  });
  const navigate = useNavigate();

  const updateStepStatus = useCallback(() => {
    switch (step) {
      case 1:
        setStepStatus({
          step1: STEP_STATUS.ACTIVE,
          step2: '',
          step3: '',
          step4: '',
        });
        break;
      case 2:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.ACTIVE,
          step3: '',
          step4: '',
        });
        break;
      case 3:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.PROCESSED,
          step3: STEP_STATUS.ACTIVE,
          step4: '',
        });
        break;
      case 4:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.PROCESSED,
          step3: STEP_STATUS.PROCESSED,
          step4: STEP_STATUS.ACTIVE,
        });
        break;
      default:
        setStepStatus({
          step1: STEP_STATUS.ACTIVE,
          step2: '',
          step3: '',
          step4: '',
        });
        break;
    }
  }, [step]);

  const updateEligibilityStatus = useCallback(() => {
    if (eligibilityStep === 1) {
      setEligibilityStatus({
        step1: STEP_STATUS.ACTIVE,
        step2: STEP_STATUS.INACTIVE,
      });
    } else {
      setEligibilityStatus({
        step1: STEP_STATUS.PROCESSED,
        step2: STEP_STATUS.ACTIVE,
      });
    }
  }, [eligibilityStep]);

  useEffect(() => {
    updateStepStatus();
  }, [updateStepStatus]);

  useEffect(() => {
    updateEligibilityStatus();
  }, [updateEligibilityStatus]);

  const handleOptionChange = useCallback((event) => {
    setConnectionOption(event.target.value);
  }, []);

  const handlePhoneValidationChange = useCallback((event) => {
    setPhoneValidationOption(event.target.value);
  }, []);

  const handleGetStarted = useCallback(() => {
    setConnectionOption((current) => {
      return step === 1 && !current ? 'new' : current;
    });
    setStep((prevStep) => prevStep + 1);
  }, [step]);

  const handleEligibilityNext = useCallback(() => {
    if (eligibilityStep === 1 && !phoneValidationOption) {
      setPhoneValidationOption('none');
      setSubStep('none');
      return;
    }

    if (phoneValidationOption === 'existing') {
      setSubStep('existing');
      return;
    }

    if (phoneValidationOption === 'none') {
      setSubStep('none');
      return;
    }

    setEligibilityStep((prevStep) => prevStep + 1);
  }, [eligibilityStep, phoneValidationOption]);

  const handleExistingNext = useCallback(() => {
    if (connectionOption === CONNECTION_OPTIONS.EXISTING_ELFOA2P) {
      setStep(3);
    } else {
      setExistingStep(2);
    }
  }, [connectionOption, setStep]);

  const handleBackStep = useCallback(() => {
    switch (step) {
      case 1:
        navigate('/dashboard/whatsapp');
        return;
      case 2:
        if (connectionOption === 'new') {
          if (eligibilityStep === 1) {
            if (subStep === '' && phoneValidationOption === '') {
              setStep((prevStep) => prevStep - 1);
              return;
            }
            setSubStep('');
            setPhoneValidationOption('');
            return;
          }
          setEligibilityStep((prevStep) => prevStep - 1);
        } else {
          setStep((prevStep) => prevStep - 1);
        }
        return;
      case 3:
        setStep((prevStep) => prevStep - 1);
        return;
      default:
        return;
    }
  }, [step, connectionOption, eligibilityStep, subStep, phoneValidationOption]);

  return {
    step,
    setStep,
    eligibilityStep,
    setEligibilityStep,
    connectionOption,
    phoneValidationOption,
    subStep,
    existingStep,
    stepStatus,
    eligibilityStatus,
    handleOptionChange,
    handlePhoneValidationChange,
    handleGetStarted,
    handleEligibilityNext,
    handleExistingNext,
    handleBackStep,
  };
};

export default useWhatsAppOnboarding;
